import type { IconSvgProps } from '../Icon.types';

export const BoundingBoxSimple = ({ width, height }: IconSvgProps) => {
  return (
    <svg
      version="1.0"
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 1024.000000 1024.000000"
      preserveAspectRatio="xMidYMid meet"
    >
      <g transform="translate(0.000000,1024.000000) scale(0.100000,-0.100000)" stroke="none">
        <path
          d="M1615 8956 c-108 -34 -195 -111 -243 -214 l-27 -57 0 -610 0 -610 32
-67 c40 -85 106 -151 191 -191 l67 -32 213 -3 212 -4 0 -2044 0 -2044 -194 0
c-166 0 -203 -3 -257 -20 -121 -38 -212 -129 -249 -250 -20 -63 -21 -87 -18
-650 l3 -585 32 -67 c40 -85 106 -151 191 -191 l67 -32 610 0 610 0 67 32 c84
39 155 109 194 188 l29 60 3 248 3 247 1969 0 1969 0 3 -242 c3 -227 5 -247
27 -301 30 -75 115 -163 196 -203 l60 -29 615 0 615 0 57 23 c81 33 160 108
200 190 l33 67 0 615 0 615 -29 62 c-35 76 -113 153 -193 191 -57 26 -64 27
-275 30 l-218 4 0 2043 0 2044 208 4 c123 2 222 8 244 16 65 21 160 92 201
151 69 99 68 88 65 751 l-3 594 -27 57 c-37 80 -107 152 -187 191 l-66 32
-620 0 -620 0 -66 -32 c-80 -39 -150 -111 -187 -191 -25 -53 -27 -68 -30 -219
l-4 -163 -1968 0 -1968 0 -4 168 c-3 158 -5 170 -30 222 -39 79 -107 146 -186
183 l-67 32 -605 2 c-468 1 -614 -1 -645 -11z m1163 -358 c17 -17 17 -1039 0
-1056 -9 -9 -140 -12 -529 -12 -285 0 -524 3 -533 6 -14 5 -16 61 -16 530 0
488 1 524 18 533 26 16 1044 15 1060 -1z m5751 -2 c8 -9 10 -159 9 -537 l-3
-524 -529 -3 c-382 -1 -533 1 -542 9 -19 16 -21 1038 -2 1057 19 19 1051 17
1067 -2z m-1437 -873 l3 -268 29 -60 c39 -79 110 -149 194 -188 l67 -32 218
-3 217 -4 0 -2044 0 -2044 -199 0 c-171 0 -208 -3 -262 -20 -120 -38 -211
-129 -249 -249 -17 -52 -20 -91 -20 -227 l0 -164 -1969 0 -1970 0 -3 188 -3
188 -33 66 c-40 82 -121 158 -202 190 -50 20 -76 23 -272 26 l-218 3 0 2044 0
2043 218 4 217 3 67 32 c89 42 151 101 191 182 l32 65 3 268 3 268 1969 0
1969 0 3 -267z m-4321 -5013 c18 -10 19 -27 19 -528 0 -390 -3 -521 -12 -530
-17 -17 -1049 -17 -1066 0 -9 9 -12 140 -12 530 0 482 1 518 18 527 24 14
1026 15 1053 1z m5750 0 c18 -10 19 -27 19 -528 0 -390 -3 -521 -12 -530 -17
-17 -1049 -17 -1066 0 -9 9 -12 140 -12 530 0 482 1 518 18 527 24 14 1026 15
1053 1z"
        />
        <path
          d="M4113 7263 c-21 -11 -157 -176 -367 -441 -184 -232 -337 -429 -340
-438 -12 -30 -6 -79 14 -111 36 -60 108 -79 165 -44 17 10 120 130 230 267
109 137 204 256 212 264 11 12 13 -26 13 -230 l0 -245 -361 -405 c-198 -223
-367 -415 -376 -428 -20 -29 -20 -89 0 -129 28 -54 109 -78 165 -49 15 8 149
152 297 319 l270 305 3 -225 2 -226 -307 -301 c-616 -601 -564 -547 -570 -598
-4 -30 0 -55 11 -76 30 -58 114 -80 167 -44 15 9 178 162 363 340 l336 323 0
-655 0 -656 -454 0 -453 0 -34 -23 c-45 -30 -61 -63 -56 -115 5 -49 28 -79 74
-98 48 -21 3958 -21 4006 0 46 19 69 49 74 98 5 52 -11 85 -56 115 -34 23 -36
23 -392 23 l-359 0 0 322 0 322 48 -44 c26 -25 115 -112 198 -193 142 -140
154 -149 196 -154 81 -9 138 41 138 122 0 20 -5 45 -11 56 -6 11 -136 145
-290 297 l-280 277 -2 168 c-1 92 1 167 5 167 3 0 86 -84 185 -186 98 -102
190 -192 205 -200 15 -8 45 -14 68 -14 32 0 48 7 78 34 34 32 37 39 37 89 l0
54 -107 114 c-60 63 -189 197 -288 299 l-179 185 -1 230 c0 132 4 225 9 220 5
-6 70 -89 146 -185 175 -224 198 -248 241 -256 103 -19 188 93 140 184 -23 42
-568 713 -596 734 -38 28 -91 33 -132 14 -26 -13 -110 -110 -320 -374 -157
-196 -290 -367 -296 -379 -7 -12 -12 -40 -12 -62 0 -81 94 -142 172 -112 16 6
85 82 175 193 81 100 163 198 180 218 l32 35 1 -226 0 -226 -278 -289 c-153
-159 -284 -299 -290 -311 -7 -12 -12 -40 -12 -63 0 -78 60 -128 143 -117 39 5
54 18 239 209 l198 203 0 -170 0 -170 -92 -95 c-51 -52 -182 -185 -290 -296
-192 -195 -198 -202 -198 -242 0 -22 4 -52 10 -66 14 -37 66 -66 119 -66 l45
0 203 202 203 202 0 -327 0 -327 -915 0 -915 0 0 656 0 655 308 -294 c398
-381 405 -387 445 -387 71 0 127 62 127 141 0 49 9 39 -532 558 l-348 334 0
230 c0 132 4 227 9 222 5 -6 124 -140 265 -300 141 -159 271 -300 288 -312 88
-64 214 21 194 129 -6 33 -31 62 -657 765 l-99 111 2 246 3 246 207 -263 c114
-145 216 -271 227 -281 11 -10 40 -21 65 -23 52 -6 105 20 124 62 15 33 15 90
1 117 -23 43 -662 849 -685 864 -37 25 -94 28 -131 7z"
        />
      </g>
    </svg>
  );
};
